import { promises as fs } from 'fs';
import { MDXRemote } from 'next-mdx-remote';
import { serialize } from 'next-mdx-remote/serialize';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import 'twin.macro';

export const getStaticProps = async () => {
	const mdxFile = await fs.readFile(
		`${process.cwd()}/pages/csp-test/test.mdx`,
		'utf8'
	);
	const mdx = await serialize(mdxFile);
	return { props: { mdx } };
};

const StaticPropsPage = ({ mdx }) => {
	const [hydrated, setHydrated] = useState(false);
	useEffect(() => {
		setHydrated(true);
	}, []);
	return (
		<div tw="max-w-7xl flex justify-center py-16">
			<article tw="prose prose-lg prose-blue max-w-5xl">
				<h1>A Page with getStaticProps</h1>
				{!hydrated && (
					<p tw="text-red-700">
						If you see me the page hasn't hydrated and is not interactive...
					</p>
				)}
				{hydrated && (
					<p tw="text-green-700">
						If you see me the page has hydrated and is interactive...
					</p>
				)}
				<p>
					It get's prerendered at build-time and has no access to request and
					response data. But it can return stuff from the repository file system
					as props.
				</p>
				<h2>Links to other pages</h2>
				<p>Too see if internal navigation works:</p>
				<ul>
					<li>
						<Link href="/csp-test/static-incremental">
							<a>
								Page with getStaticProps + <code>revalidate</code> (ISR)
							</a>
						</Link>
					</li>
					<li>
						<Link href="/csp-test/dynamic">Page with getServerSideProps</Link>
					</li>
				</ul>
				{/* <MDXRemote {...mdx} /> */}
			</article>
		</div>
	);
};

export default StaticPropsPage;
